<template>
  <div class="success-container">
    <div class="register-success">
      <div class="register-success-icon"></div>
      <div class="register-success-tip">恭喜您密码修改成功</div>
      <div class="register-success-tips">请妥善保管您的账号</div>
      <router-link to="/" class="register-success-btn">进入首页</router-link>
    </div>
  </div>
</template>

<script>
import { getHeaderData } from '../../api/getData'
export default {
  name: 'success2',
  data () {
    return {
      headerInfo: {}
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  created () {
    this.getHeaderInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
    }
  }
}
</script>

<style scoped lang="less">
  .success-container{
    position: relative;
    width: 100vw;
    height: 100vh;
    background-image: url("../../assets/images/login-bg.jpg");
    background-repeat: no-repeat;
    background-position: center top;
  }
  .register-success{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 530px;
    height: 530px;
    padding-top: 135px;
    background-color: #ffffff;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    .register-success-icon{
      width: 90px;
      height: 90px;
      margin: 0 auto;
      border-radius: 50%;
      background-image: url("../../assets/images/icons.png");
      background-repeat: no-repeat;
      background-position: -349px -267px;
    }
    .register-success-tip{
      margin-top: 30px;
      font-size: 36px;
      line-height: 36px;
      text-align: center;
      color: #333333;
    }
    .register-success-tips{
      margin-top: 20px;
      font-size: 18px;
      line-height: 18px;
      text-align: center;
      color: #999999;
    }
    .register-success-btn{
      display: block;
      width: 160px;
      height: 50px;
      margin: 42px auto 0;
      border-radius: 25px;
      background-color: #ec6420;
      font-size: 18px;
      line-height: 50px;
      text-align: center;
      color: #ffffff;
    }
  }
  @media screen and (max-width: 1200px){
    .success-container{
      width: 100%;
      height: auto;
      padding: 25px 0;
    }
    .register-success{
      position: relative;
      top: 0;
      left: 0;
      transform: none;
      width: 265px;
      height: 265px;
      margin: 0 auto;
      padding-top: 67px;
      border-radius: 5px;
      .register-success-icon{
        width: 45px;
        height: 45px;
        background-size: 230px auto;
        background-position: -174px -133px;
      }
      .register-success-tip{
        margin-top: 15px;
        font-size: 18px;
        line-height: 18px;
      }
      .register-success-tips{
        margin-top: 10px;
        font-size: 9px;
        line-height: 9px;
      }
      .register-success-btn{
        width: 100px;
        height: 30px;
        margin: 21px auto 0;
        border-radius: 15px;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
</style>
